import { render, staticRenderFns } from "./DSSelectArrowIcon.vue?vue&type=template&id=afed6144&"
import script from "./DSSelectArrowIcon.vue?vue&type=script&lang=js&"
export * from "./DSSelectArrowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports